import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SendSmsLog } from '../models/open-app/send-sms-log.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class CommonSmsLogService extends RequestService<SendSmsLog> {
  static PATH = '/common/sms/sendlog';
  constructor(
    public override httpClient: HttpClient,
    public globalService: GlobalService,
  ) {
    super(httpClient, CommonSmsLogService.PATH, globalService.debugUrl);
  }
}
